import script from "./talentConcept.vue?vue&type=script&setup=true&lang=js"
export * from "./talentConcept.vue?vue&type=script&setup=true&lang=js"

import "./talentConcept.vue?vue&type=style&index=0&id=7501d98d&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7501d98d"]])

export default __exports__